let controller1 = new ScrollMagic.Controller();

//secton4
let scene4_1 = new ScrollMagic.Scene({
    offset: 150,
    triggerElement: '.box4', 
    triggerHook: "onenter",
    duration:0,
})
scene4_1.on("progress", function () {
    $('.box4_img').hide()
    $('.box4_img2').show()
})
let scene4_2 = new ScrollMagic.Scene({
    offset: 200,
    triggerElement: '.box4', 
    triggerHook: "onenter",
    duration:0,
})
scene4_2.on("progress", function () {
    $('.box4_img').hide()
    $('.box4_img3').show()
})
let scene4_3 = new ScrollMagic.Scene({
    offset: 250,
    triggerElement: '.box4', 
    triggerHook: "onenter",
    duration:0,
})
scene4_3.on("progress", function () {
    $('.box4_img').hide()
    $('.box4_img4').show()
})
let scene4_4 = new ScrollMagic.Scene({
    offset: 300,
    triggerElement: '.box4', 
    triggerHook: "onenter",
    duration:0,
})
scene4_4.on("progress", function () {
    $('.box4_img').hide()
    $('.box4_img5').show()
})
let scene4_5 = new ScrollMagic.Scene({
    offset: 350,
    triggerElement: '.box4', 
    triggerHook: "onenter",
    duration:0,
})
scene4_5.on("progress", function () {
    $('.box4_img').hide()
    $('.box4_img6').show()
})

var box4_title=document.getElementsByClassName('box4_title');
let scene4 = new ScrollMagic.Scene({
        offset: -60,
        triggerElement: '.box4',
        triggerHook: "0",
        duration:4000,
})
scene4.setPin('.box4');
scene4.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    for(var i=7; i<76;i++){
        if(index1>(i-6)*1.2){
            $('.box4_img').hide()
            $(`.box4_img${i}`).show()
        }
    }
    if(index1>10){
        box4_title[0].classList.add("showup");
    }
    if(index1<10){
        box4_title[0].classList.remove("showup");
    }
})

var box4_title=document.getElementsByClassName('box4_title');
let sceneM4 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.Mbox4', 
        triggerHook: "onenter",
        duration:0,
})
sceneM4.on("progress", function (event) {
    box4_title[1].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box4_title[1].classList.remove("showup");
    }
})


var box5_content=document.getElementsByClassName('box5_content');
let scene5 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box5', 
        triggerHook: "onenter",
        duration:0,
})
scene5.on("progress", function (event) {
    box5_content[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box5_content[0].classList.remove("showup");
    }
})

var box5_info=document.getElementsByClassName('box5_info');
let scene5_1 = new ScrollMagic.Scene({
        offset: -60,
        triggerElement: '.box5',
        triggerHook: "0",
        duration:2000,
})
scene5_1.setPin('.box5');
scene5_1.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(index1>5){
        $('.box5_img2').css({opacity:'0'})
    }
    if(index1>10){
        $('.box5_img2').css({opacity:'0.1'})
    }
    if(index1>15){
        $('.box5_img2').css({opacity:'0.2'})
    }
    if(index1>20){
        $('.box5_img2').css({opacity:'0.3'})
    }
    if(index1>25){
        $('.box5_img2').css({opacity:'0.4'})
    }
    if(index1>30){
        $('.box5_img2').css({opacity:'0.5'})
    }
    if(index1>35){
        $('.box5_img2').css({opacity:'0.6'})
    }
    if(index1>40){
        $('.box5_img2').css({opacity:'0.7'})
    }
    if(index1>45){
        $('.box5_img2').css({opacity:'0.8'})
    }
    if(index1>50){
        $('.box5_img2').css({opacity:'0.9'})
    }
    if(index1>55){
        $('.box5_img2').css({opacity:'1'})
    }
    if(index1>65){
        $('.box5Light').hide()
        box5_info[0].classList.add("showup");
    }else{
        $('.box5Light').show()
        box5_info[0].classList.remove("showup");
    }
})

var box6_title=document.getElementsByClassName('box6_title');
let scene6 = new ScrollMagic.Scene({
        offset: 0,
        triggerElement: '.box6', 
        triggerHook: "onenter",
        duration:0,
})
scene6.on("progress", function (event) {
    box6_title[0].classList.add("showup");
    var index1=event.progress.toFixed(3) * 100;
    if(index1<2){
        box6_title[0].classList.remove("showup");
    }
})

var box10_title=document.getElementsByClassName('box10_title');
let scene10 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box10',
    triggerHook: "onenter",
    duration:0,
})
scene10.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box10_title[0].classList.add("showup");
    if(index1<2){
        box10_title[0].classList.remove("showup");
    }
})

var box7_title=document.getElementsByClassName('box7_title');
var box7_content=document.getElementsByClassName('box7_content');
let scene7 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box7',
    triggerHook: "onenter",
    duration:0,
})
scene7.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box7_title[0].classList.add("showup");
    box7_content[0].classList.add("showup");
    if(index1<2){
        box7_title[0].classList.remove("showup");
        box7_content[0].classList.remove("showup");
    }
})

var box7_info1=document.getElementsByClassName('box7_info1');
var box7_info2=document.getElementsByClassName('box7_info2');
var box7_info3=document.getElementsByClassName('box7_info3');
let scene7_1 = new ScrollMagic.Scene({
        offset: -60,
        triggerElement: '.box7',
        triggerHook: "0",
        duration:1000,
})
scene7_1.setPin('.box7');
scene7_1.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    if(index1>5){
        $('.box7_voc img').css({transform:'scale(0)'})
    }
    if(index1>10){
        $('.box7_voc img').css({transform:'scale(0.1)'})
    }
    if(index1>15){
        $('.box7_voc img').css({transform:'scale(0.2)'})
    }
    if(index1>20){
        $('.box7_voc img').css({transform:'scale(0.3)'})
    }
    if(index1>25){
        $('.box7_voc img').css({transform:'scale(0.4)'})
    }
    if(index1>30){
        $('.box7_voc img').css({transform:'scale(0.5)'})
    }
    if(index1>35){
        $('.box7_voc img').css({transform:'scale(0.6)'})
    }
    if(index1>40){
        $('.box7_voc img').css({transform:'scale(0.7)'})
    }
    if(index1>45){
        $('.box7_voc img').css({transform:'scale(0.8)'})
    }
    if(index1>50){
        $('.box7_voc img').css({transform:'scale(0.9)'})
    }
    if(index1>55){
        $('.box7_voc img').css({transform:'scale(1)'})
    }
    if(index1>65){
        box7_info1[0].classList.add("showup");
    }else{
        box7_info1[0].classList.remove("showup");
    }
    if(index1>75){
        box7_info2[0].classList.add("showup");
    }else{
        box7_info2[0].classList.remove("showup");
    }
    if(index1>85){
        box7_info3[0].classList.add("showup");
    }else{
        box7_info3[0].classList.remove("showup");
    }
})


var box8_title=document.getElementsByClassName('box8_title');
let scene8 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box8',
    triggerHook: "onenter",
    duration:0,
})
scene8.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box8_title[0].classList.add("showup");
    if(index1<2){
        box8_title[0].classList.remove("showup");
    }
})

let scene8_1 = new ScrollMagic.Scene({
        offset: -60,
        triggerElement: '.box8',
        triggerHook: "0",
        duration:1000,
})
scene8_1.setPin('.box8');
scene8_1.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    for(var i=1; i<16;i++){
        if(index1>(i-0)*6){
            $('.box8_img').hide()
            $(`.box8_img${i}`).show()
        }
    }
    if(index1>90){
        $(`.box8_img16`).css({opacity:'1'})
    }else{
        $(`.box8_img16`).css({opacity:'0'})
    }
})

var box13_title=document.getElementsByClassName('box13_title');
let scene13 = new ScrollMagic.Scene({
    offset: 0,
    triggerElement: '.box13',
    triggerHook: "onenter",
    duration:0,
})
scene13.on("progress", function (event) {
    var index1=event.progress.toFixed(3) * 100;
    box13_title[0].classList.add("showup");
    if(index1<2){
        box13_title[0].classList.remove("showup");
    }
})

controller1.addScene([scene4,scene4_1,scene4_2,scene4_3,scene4_4,scene4_5,sceneM4,scene5,
    scene5_1,scene6,scene10,scene7,scene7_1,scene8,scene8_1,scene13]); 

//section3
var box3Swiper = new Swiper('.box3Swiper', {
    effect: 'fade',
    on:{
        slideChange: function(){
            var i = this.activeIndex +1
            $('.box3_icon img:nth-child(2)').hide()
            $('.box3_icon img:nth-child(1)').css({display:'block'})
            $(`.box3_icons .box3_icon:nth-child(${i}) img:nth-child(1)`).hide()
            $(`.box3_icons .box3_icon:nth-child(${i}) img:nth-child(2)`).css({display:'block'})
        }
      },
})
$('.box3_icon').click(function(){
    var index = $(this).index()
    box3Swiper.slideTo(index, 300, false);
    $('.box3_icon img:nth-child(2)').hide()
    $('.box3_icon img:nth-child(1)').css({display:'block'})
    $(this).children('img:nth-child(1)').hide()
    $(this).children('img:nth-child(2)').css({display:'block'})
})

//section6
$('.box6_items .box6_item').click(function(){
    var index = $(this).index()+1;
    $('.box6_img').hide()
    $(`.box6_img${index}`).show()
    $('.box6_item').css({boxShadow:'none'})
    $(this).css({boxShadow:'0px 0px 12px #fff'})
})

//section10
var box10Swiper = new Swiper('.box10Swiper', {
	on:{
        slideChange: function(){
            $('.box10_btns').css({"background":"rgba(0,0,0,0)",color:'white'})
          if(this.activeIndex == 0){
            $('.Mbox10_Mline').css({opacity:'1'})
            $('.box10_line').css({opacity:'1'})
            $('.box10_mask').css({'left':'0','opacity':'1'})
            $('.box10_btns:nth-child(2)').css({color:'black'})
          }else if(this.activeIndex == 1){
            $('.Mbox10_Mline').css({opacity:'1'})
            $('.box10_line').css({opacity:'1'})
            $('.box10_mask').css({'left':'33.3%','opacity':'1'})
            $('.box10_btns:nth-child(3)').css({color:'black'})
          }else if(this.activeIndex == 2){
            $('.Mbox10_Mline').css({opacity:'0'})
            $('.box10_line').css({opacity:'0'})
            $('.box10_mask').css({'left':'66.6%','opacity':'1'})
            $('.box10_btns:nth-child(4)').css({color:'black'})
          }
        },
      },
})


$('.box10_btns').hover(function(){
    $('.box10_btns').css({"background":"rgba(0,0,0,0)",color:'white'})
    $(this).css({color:'black'})
    var index = $(this).index();
    var position = $(this).position();
    if(index == 1){
        $('.Mbox10_Mline').css({opacity:'1'})
        $('.box10_line').css({opacity:'1'})
        box10Swiper.slideTo(0, 0, false);
        $('.box10_mask').css({'left':position.left,'opacity':'1'})
    }else if(index ==2){
        $('.Mbox10_Mline').css({opacity:'1'})
        $('.box10_line').css({opacity:'1'})
        box10Swiper.slideTo(1, 0, false);
        box10Swiper.update()
        $('.box10_mask').css({'left':position.left,'opacity':'1'})
    }else if(index ==3){
        $('.Mbox10_Mline').css({opacity:'0'})
        $('.box10_line').css({opacity:'0'})
        box10Swiper.slideTo(2, 0, false);
        $('.box10_mask').css({'left':position.left,'opacity':'1'})
    }
})

//section7
$('.box7_video img').click(function(){
    $('.box7_video').hide()
    $('.box7_video video')[0].pause()
})
$('.box7_play').click(function(){
    $('.box7_video').show()
    $('.box7_video video')[0].play()
})

//section9
new Swiper('.box9Swiper', {
	navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
})

$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/products/oxva-xlim-se-2-kit'); 
})

$('.pnr_spec').click(function(){
    var element = document.querySelector(".box13");
    element.scrollIntoView({block: "end"});
})

